import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import intl from "react-intl-universal";
import Exchange from "../../Exchange";
import * as actions from "../../../store/action/exchange";
import styles from './index.module.scss';


class ExchangeModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            totalNum: window.sessionStorage.getItem('totalStar') || 0
        }
    }
    componentDidMount() {
    }

    backHome = () => {
        this.props.showDynamic({
            exchangeModalShow: false
        })
    };

    // 展示兑换规则页面
    showRuleModal = () => {
        this.props.changeRuleModalVisible(true);
    };

    render() {
        const { addressModalVisible } = this.props;
        return (
            <React.Fragment>
                <div className={styles.modalContainer} style={{zIndex: addressModalVisible ? 10001 : 10000}}>
                    <header className={styles.header}>
                        <p className={styles.title}>{intl.get('STAR_EXCHANGE')}</p>
                        <span className={styles.rule} onClick={this.showRuleModal}>{intl.get('STAR_EXCHANGE_RULE')} &gt;</span>
                        <i onClick={() => this.backHome()}/>
                    </header>
                    <Exchange
                        pageType="modal"
                    />
                </div>
            </React.Fragment>
        )
    }
}

const mapStateToProps = state => ({
    ...state.exchange
});

const mapDispatchToProps = dispatch => bindActionCreators(actions, dispatch);

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ExchangeModal);